import { useState, useEffect } from 'react';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import Dialog from 'components/Dialog';
import Spacing from 'components/Spacing';

type Props = {
  title: string;
  open: boolean;
  hideDescription?: boolean;
  onClose: () => void;
  onConfirm: (date: Date) => void;
};

const DownloadStatementDialog: React.FC<Props> = ({
  title,
  open,
  hideDescription = false,
  onClose,
  onConfirm,
}) => {
  const [date, setDate] = useState(null);

  useEffect(() => {
    if (!open) {
      setDate(null);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      onConfirm={() => {
        if (date) {
          onConfirm(date);
        }
      }}
      title={title}
      btnLabels={{ cancel: 'Go back', confirm: 'Download statement' }}
      confirmButtonDisabled={!date}
    >
      <Spacing>
        {hideDescription ? null : (
          <p>
            Your download will display holdings, advice fees and commission as
            at the selected date.
          </p>
        )}
        <DateCalendar value={date} onChange={setDate} disableFuture />
      </Spacing>
    </Dialog>
  );
};

export default DownloadStatementDialog;
